// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"86":"auth-module","537":"main-module"}[chunkId] || chunkId) + "." + {"86":"bb2b475a","125":"bbd88f14","179":"45064f2b","234":"4305e14b","537":"6325b8d0"}[chunkId] + ".js";
};